/** Paint an arrival on existing nodes. It never owns navigation, data or focus. */
const arrivals = new WeakMap();
const visits = new WeakMap();
function arrive(root, { layered = true } = {}) {
  if (!root) return () => {};
  arrivals.get(root)?.();
  const visit = (visits.get(root) || 0) + 1;
  visits.set(root, visit);
  const mark = visit % 2 ? "pa-arrive-a" : "pa-arrive-b";
  const children = layered ? Array.from(root.children).filter(node => !node.hidden && !["SCRIPT", "STYLE"].includes(node.tagName)) : [];
  const nodes = children.length > 1 ? children : [root];
  const cancel = () => {
    if (arrivals.get(root) !== cancel) return;
    arrivals.delete(root);
    for (const node of nodes) {
      node.classList.remove(mark);
      node.style.removeProperty("--pa-arrival-delay");
    }
  };
  arrivals.set(root, cancel);
  nodes.forEach((node, order) => {
    node.style.setProperty("--pa-arrival-delay", `${Math.min(order * 45, 180)}ms`);
    node.classList.add(mark);
  });
  return cancel;
}
export { arrive };
